import { usePairingStore } from '@/stores/PairingStore.js'
import { useParticipateStore } from '@/stores/ParticipateStore.js'
import { useSettingsStore } from '@/stores/SettingsStore.js'
import { useTableStore } from '@/stores/TableStore.js'

export function useAssignment() {
    const pairingStore = usePairingStore()
    const participateStore = useParticipateStore()
    const settingsStore = useSettingsStore()
    const tableStore = useTableStore()

    function assignAllParticipates(randomize = false) {
        tableStore.tables.forEach((table) => {
            const retained = table.participates.filter((participateID) => {
                return participateStore.get(participateID).lock
            })

            tableStore.setParticipants(table.uuid, retained)
        })

        let participates = [...participateStore.participates]
        let pairings = [...pairingStore.pairings]

        let tablesNeeded = Math.ceil(participateStore.participates.length / settingsStore.tableSize)

        if (tablesNeeded > tableStore.tables.length) {
            for (var i = 0; i < (tablesNeeded - tableStore.tables.length); i++) {
                tableStore.createNewTable()
            }
        }

        participates.forEach((participate) => {
            participate.assignedTable = participate.lock
        })

        pairings.forEach((pairing) => {
            let smallestTable = Infinity
            let tableID = null

            for (var i = 0; i < tablesNeeded; i++) {
                if (tableStore.tables[i].participates.length < smallestTable) {
                    smallestTable = tableStore.tables[i].participates.length
                    tableID = tableStore.tables[i].uuid
                }
            }

            pairing.participates.forEach((pairingParticipateID) => {
                let participate = participateStore.get(pairingParticipateID)

                if (tableID && participate.lock == false) {
                    tableStore.assign(tableID, [participate.uuid])
                    participate.assignedTable = true
                }
            })
        })

        if (randomize) {
            for (let i = participates.length - 1; i > 0; i--) {
                const j = Math.floor(Math.random() * (i + 1));
                [participates[i], participates[j]] = [participates[j], participates[i]]
            }
        }

        participates.forEach((participate) => {
            if (participate.assignedTable == false && participate.lock == false) {
                let smallestTable = Infinity
                let tableID = null

                for (var i = 0; i < tablesNeeded; i++) {
                    if (tableStore.tables[i].participates.length < smallestTable) {
                        smallestTable = tableStore.tables[i].participates.length
                        tableID = tableStore.tables[i].uuid
                    }
                }

                if (tableID) {
                    tableStore.assign(tableID, [participate.uuid])
                    participate.assignedTable = true
                }
            }
        })

        participateStore.setAllLocked(true)
    }

    return { assignAllParticipates }
}
